// @flow

import { connect } from 'react-redux';

import * as Account from 'app/entities/Account';
import TaskReplayCompleteMessage from 'app/viewport/components/TaskReplayCompleteMessage';
import ViewportActions from 'app/viewport/ViewportActions';

import type { HOC } from 'recompose';

import type { Dispatch } from 'app/common/types';

type TaskReplayCompleteMessageProps = {
  onSeeDetails: () => void,
  isFreePlan: boolean,
};

const mapStateToProps = (state: {}) => {
  const currentAccount = Account.selectors.all.currentAccount(state);
  return {
    isFreeAccount: Account.selectors.isFree(currentAccount),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    onSeeDetails() {
      dispatch(ViewportActions.toggleNotificationsDropdown());
    },
  };
};

const TaskReplayCompleteMessageContainer: HOC<
  *,
  TaskReplayCompleteMessageProps
> = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default TaskReplayCompleteMessageContainer(TaskReplayCompleteMessage);
